import {$document,$window,elementsTweenX,elementsTweenY} from './lib/Variables';
import {show,hide,tweenX,tweenY} from './lib/Toggle';
import {scrollTo,getScrollBottom,SmoothScroll} from './lib/ScrollTo';
import BackToTop from './lib/BackToTop';
import parallax from './lib/Parallax';
import ScrollFade from './lib/ScrollFade';
import magnificPopup from 'magnific-popup';
import App from './lib/Modal.js'

const hero = {
  element: '.js-scroll-content',
  target: '.intro__wrapper',
  options: {
    y: -200,
    ease: Power4.easeInOut
  }
};

const backToTop = {
  element: '.js-back-to-top',
  target: 0,
  options: {
    ease: Power4.easeInOut,
    position: 200
  }
};

const setFadeIn = (elements,callback) => {
  elements.forEach(function(element){
    let fade = new ScrollFade(element.element,element.options);
    fade.in(callback);
  });
};

const init = {
  hero: new SmoothScroll(hero.element,hero.target,hero.options),
  top: new BackToTop(backToTop.element,backToTop.target,backToTop.options),
  fade: setFadeIn,
};

$document.ready(function(){

    init.hero.setScroll();
    init.hero.toggle();
    init.top.setScroll();
    init.top.toggle();
    init.fade(elementsTweenX,tweenX);
    init.fade(elementsTweenY,tweenY);
    parallax();
    App.mfp.init();

});